import { Component, Input } from '@angular/core';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'qr-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
})
export class AvatarComponent {
  @Input() src: string = '';
  @Input() size: number = 0;
  @Input() error?: string = '';
  constructor(public Utils: UtilsService) {}
}
